import { toast } from 'sonner';

/**
 * Trata erros de API e exibe mensagens amigáveis
 * @param {Error} error - Erro do Axios
 * @param {string} defaultMessage - Mensagem padrão se não houver mensagem específica
 */
export function handleApiError(error, defaultMessage = 'Erro ao processar solicitação') {
  console.error('API Error:', error);
  console.error('Error details:', error.response?.data);

  if (!error.response?.data) {
    toast.error(defaultMessage);
    return;
  }

  const { message, errors } = error.response.data;

  // Se houver erros detalhados por campo
  if (errors && Array.isArray(errors) && errors.length > 0) {
    errors.forEach(err => {
      if (err.field && err.message) {
        // Traduzir nomes de campos para português
        const fieldNames = {
          name: 'Nome',
          code: 'Código',
          cnpj: 'CNPJ',
          email: 'E-mail',
          phone: 'Telefone',
          address: 'Endereço',
          city: 'Cidade',
          state: 'Estado',
          zipCode: 'CEP',
          tradeName: 'Nome Fantasia',
          planId: 'Plano',
          maxUsers: 'Máx. Usuários',
          maxTickets: 'Máx. Tickets',
        };
        
        const fieldName = fieldNames[err.field] || err.field;
        toast.error(`${fieldName}: ${err.message}`);
      } else if (err.message) {
        toast.error(err.message);
      }
    });
    return;
  }

  // Mensagem simples
  if (message) {
    toast.error(message);
    return;
  }

  // Fallback
  toast.error(defaultMessage);
}

/**
 * Extrai mensagem de erro do response
 * @param {Error} error - Erro do Axios
 * @param {string} defaultMessage - Mensagem padrão
 * @returns {string} Mensagem de erro
 */
export function getErrorMessage(error, defaultMessage = 'Erro desconhecido') {
  if (!error.response?.data) {
    return defaultMessage;
  }

  const { message, errors } = error.response.data;

  if (errors && Array.isArray(errors) && errors.length > 0) {
    return errors.map(err => err.message || String(err)).join(', ');
  }

  return message || defaultMessage;
}
